import { useRef, useState, ClipboardEvent as ReactClipboardEvent, useEffect } from 'react';

import { useAppDispatch } from '../../state/store';
import { addJournalEntry } from '../../state/features/app';
import SelectModel from '../../components/SelectModel';

import styles from './styles.module.scss';

interface WriterProps {}

export default function Writer({}: WriterProps) {
    const placeHolder = '書く';
    const [input, setInput] = useState(placeHolder);
    const textareaDivRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();

    const handlePaste = (e: ReactClipboardEvent<HTMLDivElement>) => {
        e.preventDefault();

        // Get plain text from clipboard
        const plainText = e.clipboardData?.getData('text/plain') || '';

        // Insert the plain text at the cursor position
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            const textNode = document.createTextNode(plainText);
            range.insertNode(textNode);

            // Move cursor to the end of inserted text
            range.setStartAfter(textNode);
            range.setEndAfter(textNode);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        // Command + Enter to submit
        if (e.key === 'Enter' && e.metaKey) {
            e.preventDefault();
            handleSubmit();
        } else {
            const plainText = textareaDivRef.current?.innerText || '';
            setInput(plainText);
        }
    };

    const handleSubmit = () => {
        const text = textareaDivRef.current?.innerText || '';
        // Handle the submitted text (e.g., send it to the server or process it)
        dispatch(addJournalEntry(text));
        // Clear the textarea after submission
        setInput(placeHolder);
    };

    const handleFocus = () => {
        if (input === placeHolder) {
            textareaDivRef.current!.innerText = '';
        }
    };
    const handleBlur = () => {
        if (textareaDivRef.current?.innerText.trim() === '') {
            textareaDivRef.current.innerText = placeHolder;
        }
    };

    return (
        <div className={styles.Writer}>
            <div className={styles.wrapper}>
                <div className={styles.textareaContainer}>
                    <div
                        ref={textareaDivRef}
                        className={styles.textarea + ' ' + (input === placeHolder ? styles.hasPlaceholder : '')}
                        contentEditable={true}
                        onPaste={handlePaste}
                        onKeyDown={handleKeyDown}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        spellCheck="false"
                        autoCorrect="off"
                        autoCapitalize="off"
                        suppressContentEditableWarning={true}
                    >
                        書く
                    </div>
                </div>
                <button className={styles.submitButton} onClick={handleSubmit} disabled={input === placeHolder}>
                    Submit
                </button>
            </div>

            {/* <SelectModel /> */}
        </div>
    );
}
